import { addMinutes } from "date-fns";
export const getUniqueKeyForStripPriorityRowData = (
  trailerNumber,
  trailerScac
) => {
  return trailerNumber?.toUpperCase() + trailerScac?.toUpperCase();
};

export const appendTimeInMinutesToDate = (
  planDate,
  defaultDockStartTimeInMins
) => {
  const dateWithTime = addMinutes(
    new Date(planDate),
    defaultDockStartTimeInMins
  );
  return dateWithTime.toISOString();
};
